import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useUpdatePortalBasics from "@babackapp/private-api-client/client/use-update-portal-basics";
import CustomerPortalBasicsForm from "./customer-portal-basics-form.tsx";
import { CustomerPortalFormValues } from "./use-customer-portal-basics-form.ts";
import { CustomerSegmentsForm } from "./customer-segments-form.tsx";
import { SettingsFormSectionHeader } from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";

export default function CustomerPortalBasicsCard() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: update } = useUpdatePortalBasics(shop);

  const onSubmit = (data: CustomerPortalFormValues) => {
    return update({
      contactLink: data.contactLink,
      languages: data.languages,
      webOrderOnly: data.webOrderOnly,
      nonReturnableMetafieldItems: data.nonReturnableMetafieldItems,
      tagsForNotAcceptedOrder: data.tagsForNotAcceptedOrder,
      nonReturnableItems: data.nonReturnableItems,
      restockOnReturn: data.restockOnReturn,
      restockLocationId: data.restockLocationId ?? undefined,
      autoTreateOnLogisticianValidate: data.autoTreateOnLogisticianValidate,
      clientCanUpdatePersonalInformation:
        data.clientCanUpdatePersonalInformation,
      canCancelReturnRequest: data.canCancelReturnRequest,
      allowOnlyUniqueReturnRequest: data.allowOnlyUniqueReturnRequest,
      refundInitialShippingRule: data.refundInitialShippingRule,
      oneResolutionPerReturn: data.oneResolutionPerReturn,
      groupItemsByFulfillment: data.groupItemsByFulfillment,
      refundInitialShippingAmountRule: data.refundInitialShippingAmountRule,
    });
  };

  return (
    <CustomerPortalBasicsForm
      onSubmit={onSubmit}
      workflowLogisticianActivated={shop.workflowLogistician.activated}
      defaultValues={{
        contactLink: shop.preferences.contactLink,
        languages: shop.preferences.languages,
        webOrderOnly: shop.preferences.webOrderOnly,
        canCancelReturnRequest: shop.preferences.canCancelReturnRequest,
        allowOnlyUniqueReturnRequest:
          shop.preferences.allowOnlyUniqueReturnRequest,
        nonReturnableMetafieldItems:
          shop.preferences.nonReturnableMetafieldItems,
        nonReturnableItems: shop.preferences.nonReturnableItems,
        tagsForNotAcceptedOrder: shop.preferences.tagsForNotAcceptedOrder,
        restockOnReturn: shop.preferences.restockOnReturn,
        restockLocationId: shop.preferences.restockLocationId ?? null,
        autoTreateOnLogisticianValidate:
          shop.preferences.autoTreateOnLogisticianValidate,
        clientCanUpdatePersonalInformation:
          shop.preferences.clientCanUpdatePersonalInformation,
        refundInitialShippingRule:
          shop.preferences.refundInitialShippingRule,
        oneResolutionPerReturn: shop.preferences.oneResolutionPerReturn,
        singleArticleReturnOnly: shop.preferences.singleArticleReturnOnly,
        groupItemsByFulfillment: shop.preferences.groupItemsByFulfillment,
        refundInitialShippingAmountRule:
          shop.preferences.refundInitialShippingAmountRule,
      }}
    >
      <div className="mt-8">
        <SettingsFormSectionHeader
          title={t("settings.config.customerSegments.title")}
          id={"customer-segments"}
        />
      </div>
      <Card className="w-full">
        <CardContent className="pt-6">
          <CustomerSegmentsForm />
        </CardContent>
      </Card>
    </CustomerPortalBasicsForm>
  );
}
